export default {
  title: 'Asistență Contact',
  form: {
    firstName: 'Prenumele',
    lastName: 'Numele',
    nickname: 'Porecla',
    phoneNumber: 'Numărul de Telefon',
    email: 'E-mail',
    emailVerification: 'Confirmare E-mail',
    subject: {
      label: 'Subiect',
      options: ['Eroare', 'Factură', 'Conexiune', 'Feedback', 'Îmbunătățire'],
    },
    message: 'Mesaj',
    button: 'Trimite',
  },
  errors: {
    requiredField: 'Acest câmp este obligatoriu.',
    sendFailed: 'A apărut o eroare, încercați din nou mai târziu',
  },
  success: {
    title: 'Am înţeles!',
    message:
      'Unul dintre reprezentanții noștri de asistență vă va contacta cât mai curând posibil.',
  },
};
